<div class="row g-3">
  <div class="col-lg-8 mb-0">
    <div class="card mb-3">
      <div class="card-body p-3 pb-0">
          <div class="input-group mt-0 mb-3 shadow">
            <span class="input-group-text" style="border: none !important; background-color: #eee !important;">
              <img alt="Sparkles" i18n-alt src="assets/images/sparkles.webp" style="width: 1.2rem; height: 1.2rem; position: relative; top: -2px;"></span>
            <div #promptInput enterkeyhint="send"
              (keydown.enter)="agentSend(); $event.preventDefault();"
              [attr.placeholder]="firstPromptSent ? '': placeholderText" contenteditable="true"
              class="textarea form-control" style="border: none !important; outline: none !important; box-shadow: none !important;">
            </div>
            <button *ngIf="!isMobile" (click)="agentSend()" class="btn btn-primary">
              <span class="d-none d-sm-inline me-1" i18n>Send</span>
              <fa-icon [icon]="fa.faPaperPlane" style="color: #fff;" class="plane-sm-hack"></fa-icon>
            </button>
          </div>

          <div class="m-2">
            <div class="row">
              <div class="p-0" style="width: 3rem; height: 3.5rem;">
                <img alt="Nuuduu logo" i18n-alt src="assets/images/logo-round.webp"
                  style="border-radius: 50%; width: 3rem;" class="pr-5 shadow mx-1">
              </div>
              <div class="col align-middle px-3">
                <div class="text-muted" i18n>Sales Agent</div>
                <div *ngIf="!firstPromptSent" class="d-inline-block">
                  <p>
                    {{ prompt | translateField: 'greeting' }}
                    <span *ngIf="!prompt" [innerHTML]="animatedDots"></span>&nbsp;
                  </p>
                </div>
                <div *ngIf="firstPromptSent && agentResponse == ''" class="d-inline-block">
                  <p>
                    <span [innerHTML]="animatedDots"></span>&nbsp;
                  </p>
                </div>
                <div *ngIf="firstPromptSent && agentResponse != ''" class="d-inline-block" [innerHTML]="agentResponse"></div>
                <div *ngIf="agentReponseAssignments.length > 0 || agentResponseProducts.length > 0" class="mb-2"
                  style="margin-top: -1rem;">
                  <span *ngFor="let assignment of agentReponseAssignments; let i = index"
                    class="badge rounded-pill bg-primary me-2" style="cursor: pointer;"
                    (click)="selectAssignmentWithPrompt(assignment)">{{ assignment | translateField: 'name'
                    }}</span>
                  <span *ngFor="let product of agentResponseProducts; let i = index"
                    class="badge rounded-pill bg-primary me-2" style="cursor: pointer;"
                    (click)="addAiProduct(product)">{{ getProduct(product.product_id) | translateField: 'name'
                    }}</span>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

    <div *ngIf="assginmentLoaded" class="row">
      <div class="col">
        <div class="card m-0 mb-3" style="overflow: hidden;">
          <div class="card-body d-flex align-items-center justify-content-between"
            [style.background-image]="'url(' + assignment.picture + ')'"
            style="background-size: cover; background-position: center; min-height: 17rem; overflow: hidden;">
            <div class="d-flex align-items-center position-absolute rounded bottom-0"
              style="background: rgba(255,255,255,0.85); padding: 1rem; margin: 0 1rem 1rem 0.5rem;">
              <div>
                <button (click)="salaryRules()" *ngIf="assignment.salary_rules_id" type="button"
                  class="btn btn-sm btn-primary float-end" i18n>Pricing rules</button>
                <h4 (click)="router.navigate(['/'])" class="card-title cursor-pointer">
                  <fa-icon [icon]="fa.faChevronCircleLeft" style="font-size: 1.7rem; position: relative; top: 2px;"
                    class="me-1 cursor-pointer"></fa-icon>
                  {{ assignment | translateField: 'name' }}
                  <ng-container *ngIf="assignment.remote_work">(<span i18n>remote
                      work</span>)</ng-container>
                </h4>
                <p class="card-text">{{ assignment | translateField: 'description' }}</p>
                <p *ngIf="assignment.description_local" class="card-text">{{ assignment |
                  translateField: 'description_local' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="productsLoaded" class="d-flex flex-column mb-3">
        <button *ngIf="products.length != productsAll.length" (click)="showAllProducts()" class="btn btn-primary w-100 mb-4" i18n>Show
          all</button>
        <div class="row g-3">
          <ng-container *ngFor="let product of products | localeSort: 'name'">
            <div class="col-12 col-sm-6 d-flex">
              <div class="card m-0 w-100" [style.background-image]="'url(' + product.picture + ')'"
                style="background-size: cover; background-position: center; min-height: 17rem; overflow: hidden;">
                <div class="card-header" style="height: 12rem; border: none;"></div>
                <div class="card-body p-3 d-flex flex-column" style="background: rgba(255,255,255,0.85);">
                  <h4>{{ product | translateField: 'name' }} (<span style="text-transform: lowercase;">{{
                      product.unit | i18nSelect: productUnits }}</span>)</h4>
                  <p>{{ product | translateField: 'description' }}</p>
                  <p *ngIf="product.description_local">{{ product | translateField: 'description_local' }}</p>

                  <button (click)="orderProduct(product)" type="button" class="btn btn-primary mt-auto">
                    <span i18n="Order button for ordering a product">Order</span>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- "Looking for something else?" Box -->
          <div class="col-12 col-sm-6 d-flex">
            <div class="card m-0 w-100" [style.background-image]="'url(assets/images/idea.webp)'"
              style="background-size: cover; background-position: center; min-height: 17rem; overflow: hidden;">
              <div class="card-header" style="height: 12rem; border: none;"></div>
              <div class="card-body p-3 d-flex flex-column" style="background: rgba(255,255,255,0.85);">
                <p class="mb-2" i18n>Looking for something else? Tell us about it.</p>
                <div class="input-group mt-auto">
                  <input class="form-control" type="text" #productRequest>
                  <button type="button" (click)="productRequestSend()" class="btn btn-primary">
                    <span i18n>Send</span>
                    <fa-icon [icon]="fa.faPaperPlane" style="color: #fff; margin-left: 0.3rem;"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!productsLoaded" class="text-center my-5">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    </div>
  </div>
  <div class="col-lg-4 mt-0 mt-lg-3" id="your-order">
    <div class="card mb-3">
      <div class="card">
        <div class="card-body p-3">
          <h5 i18n>Your order</h5>
          <p *ngIf="orderProducts.length == 0" i18n>Your order is empty. Select services by clicking the
            "Order".
          </p>
          <div *ngIf="orderProducts.length > 0" class="row mb-0">
            <div *ngFor="let product of orderProducts; let i = index" class="col-12 mb-3 d-flex align-items-center">
              <img [alt]="product.product | translateField: 'name'" [src]="product.product.picture" class="me-2"
                style="width: 4rem; height: 4rem; border-radius: 50%; object-fit: cover;">
              <div class="flex-grow-1">
                <div>{{ product.number | number: '1.0-2' }} x <strong>{{ product.product | translateField:
                    'name'
                    }}</strong> (<span style="text-transform: lowercase;">{{ product.product.unit | i18nSelect:
                    productUnits
                    }}</span>)</div>
                <div *ngIf="product.notes" class="text-muted">{{ product.notes }}</div>
              </div>
              <div class="ms-2 text-nowrap">
                <button (click)="editProduct(i)" class="btn btn-primary me-1">
                  <fa-icon [icon]="fa.faEdit" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                </button>
                <button (click)="deleteProduct(i)" class="btn btn-danger">
                  <fa-icon [icon]="fa.faTrash" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                </button>
              </div>
            </div>
          </div>
          <button *ngIf="orderProducts.length > 0" (click)="router.navigate(['/schedule'])" type="button" class="btn btn-primary w-100"
            i18n>Next</button>
        </div>
      </div>
    </div>
    <div (click)="router.navigate(['/partners', feedback.employee.referral_code], { queryParams: { services: translateField.transform(assignment, 'slug') } })" *ngFor="let feedback of feedbacks"
      class="card cursor-pointer mb-3">
      <div class="card-body p-3">
        <div class="row mb-2">
          <div class="col">
            <span class="float-end" style="position: relative; top: 4px;">{{ feedback.created_at | date: 'shortDate'
            }}</span>
          <div class="float-start">
            <fa-icon *ngIf="feedback.rating >= 1" [icon]="fa.faStar" size="lg" style="color: #ffd700;"
              class="me-1"></fa-icon>
            <fa-icon *ngIf="feedback.rating >= 2" [icon]="fa.faStar" size="lg"  style="color: #ffd700;"
              class="me-1"></fa-icon>
            <fa-icon *ngIf="feedback.rating >= 3" [icon]="fa.faStar" size="lg"  style="color: #ffd700;"
              class="me-1"></fa-icon>
            <fa-icon *ngIf="feedback.rating >= 4" [icon]="fa.faStar" size="lg"  style="color: #ffd700;"
              class="me-1"></fa-icon>
            <fa-icon *ngIf="feedback.rating >= 5" [icon]="fa.faStar" size="lg"  style="color: #ffd700;"
              class="me-1"></fa-icon>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col-auto pe-0">
            <img [alt]="'Picture of ' + feedback.employee.first_name" [src]="feedback.employee.picture"
          style="border-radius: 50%; width: 4rem; height: 4rem; object-fit: cover;" class="me-0">
          </div>
          <div class="col ps-2">
            <p>{{ feedback | translateField: 'feedback' }}</p>
            <div>
              {{ feedback.employee.first_name }},
              <span class="text-muted"><span i18n>Partner since</span>&nbsp;{{ feedback.employee.created_at | date:
                'MMM yyyy' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="card">
        <div class="card-body p-3">
          <h5 i18n>How to order?</h5>
          <ol class="mb-0">
            <li i18n>Choose the services you need and inform the Sales Agent any special requests you have.</li>
            <li i18n>Select your location where the work is to be performed and a suitable date.</li>
            <li i18n>Choose a partner using ratings, price and avaialble times.</li>
            <li i18n>Confirm and enter your payment card details.</li>
          </ol>
          <h5 class="mt-3" i18n>What happens next?</h5>
          <ol class="mb-0">
            <li i18n>Your order is sent to the partner, who must accept or refuse it within 1 hour. You'll be
              notified.</li>
            <li i18n>24 hours before the work starts, a hold is placed on your payment card.</li>
            <li i18n>You can cancel for free up until the hold is placed.</li>
            <li i18n>The partner checks in via GPS at the scheduled time and starts work. You'll be notified.
            </li>
            <li i18n>After checkout, you'll get a notification and be asked to leave feedback.</li>
            <li i18n>You'll be charged 1 hour after the job is done.</li>
            <li i18n>If the partner doesn't show up, you'll receive a full refund.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>

<button *ngIf="orderProducts.length > 0" (click)="scrollToOrder()"
  class="btn btn-secondary rounded-circle position-fixed d-lg-none"
  style="bottom: 20px; right: 20px; width: 60px; height: 60px; z-index: 1000;">
  <fa-icon [icon]="fa.faShoppingCart" style="font-size: 1.5rem; color:#fff;"></fa-icon>
  <span class="position-absolute bg-primary text-white rounded-pill px-2" style="top: 8px; right: 8px;">{{
    orderProducts.length }}</span>
</button>